import { useCallback, useState } from 'react';

import { useLanguage } from '../../contexts/language';
import { settle, unreachable } from '../../hooks/request';

import styles from './style.module.css';

// Save as PDF (#85): asks the reports service for the file at `href` and
// saves it as a download, under the name the service gave it. The service
// re-checks access every time, so a button left on screen after care ended
// is refused like any read. A refusal or a failure is shown under the button
// in the interface language, and the button can be pressed again.
export function SavePdf({ href }) {
  const { text, translate } = useLanguage();
  const [ busy, setBusy ] = useState(false);
  const [ error, setError ] = useState();

  const onClick = useCallback(function() {
    setBusy(true);
    setError();

    return fetch(href).catch(function() {
      throw new Error(unreachable);
    }).then(function(response) {
      if (response.ok === false) {
        return settle(Promise.resolve(response));
      }

      const disposition = /filename="([^"]+)"/.exec(response.headers.get('Content-Disposition'));

      return response.blob().then(function(blob) {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.download = disposition[ 1 ];
        link.click();
        URL.revokeObjectURL(url);
      });
    }).then(function() {
      setBusy(false);
    }).catch(function(failed) {
      setBusy(false);
      setError(failed.message);
    });
  }, [ href ]);

  let message = null;

  if (error != null) {
    message = <span className={ styles.error } role='alert'>{ translate(error) }</span>;
  }

  let label = text.saveAsPdf;

  if (busy === true) {
    label = text.preparingPdf;
  }

  return (
    <div className={ styles.save }>
      <button className={ styles.button } type='button' disabled={ busy } onClick={ onClick }>{ label }</button>

      { message }
    </div>
  );
}
